import { useQuery } from '@tanstack/react-query';

import { storage } from '@hero/utils';

import { organizationServices } from '../../index';

export const useGetProviderUrl = (options = {}) => {
  const userToken = storage.getUserToken();

  return useQuery(['providerUrl'], () => organizationServices.getProviderUrl(), {
    ...options,
    enabled: !!userToken && !options?.enabled,
    cacheTime: Infinity,
    staleTime: Infinity,
    retry: false
  });
};
